import { MethodsForScopeDto, MethodsWithScopeIdDto } from './method.model';
import { Book, Method } from '@lyceo/lyceo-pupil-app/practise/util-models';

export function mapMethodsForScopeToMethods(
  methodsForScopeDto: MethodsForScopeDto,
): Method[] {
  return Array.from(
    methodsForScopeDto.methodsForScopeResponses
      .reduce(
        (
          methods: Map<string, Method>,
          methodsWithScopeIdDto: MethodsWithScopeIdDto,
        ) => {
          for (const methodDto of methodsWithScopeIdDto.methods) {
            const methodInMap: Method | undefined = methods.get(methodDto.id);
            if (methodInMap) {
              methods.set(methodDto.id, {
                id: methodDto.id,
                name: methodDto.name,
                scopeIds: [...methodInMap.scopeIds, methodsWithScopeIdDto.id],
              });
            } else {
              methods.set(methodDto.id, {
                id: methodDto.id,
                name: methodDto.name,
                scopeIds: [methodsWithScopeIdDto.id],
              });
            }
          }
          return methods;
        },
        new Map<string, Method>([]),
      )
      .values(),
  );
}

export function mapMethodsToBooks(
  methodsForScopeDto: MethodsForScopeDto,
): Book[] {
  return Array.from(
    methodsForScopeDto.methodsForScopeResponses
      .reduce(
        (
          books: Map<string, Book>,
          methodsWithScopeIdDto: MethodsWithScopeIdDto,
        ) => {
          for (const methodDto of methodsWithScopeIdDto.methods) {
            for (const bookSummaryDto of methodDto.books) {
              const bookInMap: Book | undefined = books.get(bookSummaryDto.id);
              if (bookInMap && bookInMap.scopeIds) {
                books.set(bookSummaryDto.id, {
                  id: bookSummaryDto.id,
                  name: bookSummaryDto.name,
                  methodId: methodDto.id,
                  scopeIds: [...bookInMap.scopeIds, methodsWithScopeIdDto.id],
                });
              } else {
                books.set(bookSummaryDto.id, {
                  id: bookSummaryDto.id,
                  name: bookSummaryDto.name,
                  methodId: methodDto.id,
                  scopeIds: [methodsWithScopeIdDto.id],
                });
              }
            }
          }
          return books;
        },
        new Map<string, Book>([]),
      )
      .values(),
  );
}
